import React from "react";
import "./FullPageModal.scss";
import {MDBModal, MDBModalBody} from "mdbreact";
import {assetUrl} from "../../serviceApi";

const CloseIcon = assetUrl+"images/close-icon-grey.png";
const ArrowLeftIcon = assetUrl+"images/blue-arrow-left.svg";


class FullPageModal extends React.Component{
    render() {
        return(
            <div
                className={`full-page-modal-component ${this.props.setBackground === true?"modal-background":""}`}
            >
                <MDBModal isOpen={this.props.isOpen} toggle={this.props.closeModal} fullHeight position="bottom">
                    {/*<MDBModalHeader className="modal-title" style={{color:"#AB8EF5"}} >*/}
                    {/*    */}
                    {/*</MDBModalHeader>*/}
                    <MDBModalBody>
                        <div className={"d-flex justify-content-between align-items-start custom-modal-header"}>
                            {
                                this.props.title?
                                    <p>{this.props.title}</p>:
                                    <img src={ArrowLeftIcon} alt={"ArrowLeftIcon"} onClick={this.props.closeModal}/>
                            }
                            <img src={CloseIcon} alt={"CloseIcon"} onClick={this.props.closeModal}  />
                        </div>
                        {this.props.children}
                    </MDBModalBody>
                </MDBModal>
            </div>
        );
    }
}

export default FullPageModal;